var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShuru(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.764h12",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.205 1.463a1 1 0 00-1.414 0L2.596 8.66a1 1 0 00-.291.651l-.168 3.026a.5.5 0 00.526.527l3.026-.168a1 1 0 00.652-.291l7.195-7.196a1 1 0 000-1.414l-2.33-2.33zm-.707.707l2.33 2.331-.81.81-2.33-2.33.81-.81zm.813 3.849l-2.33-2.331-5.678 5.678-.137 2.468 2.468-.137 5.677-5.678z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_shuru.a64c7a94.svg";
export { SvgTongyongShuru as ReactComponent };